import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerProvider } from './server';

@Injectable()
export class TipoQueixaProvider {
  private cache: Array<any>;

  constructor(private serverProvider: ServerProvider) {
  }

  public get(): Observable<Array<any>> {
    return Observable.create((observer) => {
      if (this.cache) {
        observer.next(this.cache);
        observer.complete();
        return;
      }

      this.loadItems().subscribe(
        (items) => {
          this.cache = [];
          items.forEach((i) => {
            this.cache.push({
              id: i.id,
              nome: i.nome,
            });
          });

          observer.next(this.cache);
          observer.complete();
        },
        (error) => { observer.error(error); }
      );
    });
  }

  public loadItems(): Observable<Array<any>> {
    return Observable.create((observer) => {
      this.serverProvider.postData({ "operacao": "TIPO_QUEIXA_LISTAR" }).subscribe(
        (data) => {
          if (data && data.tiposQueixa) {
            observer.next(data.tiposQueixa);
          } else {
            observer.next([]);
          }
          observer.complete();
        },
        (error) => { observer.error(error); }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/tipo-queixa.ts